<template>
  <OmtLayoutContainer>
    <OmtRow>
      <OmtTypography color="var(--colors-light-primary-gray1)" as="h2-bold"> Omint Seguro Viagem</OmtTypography>
    </OmtRow>

    <template>
      <OmtRow mt="16px" mb="16px" @click="exibirContato">
        <CardTile
          v-bind="{
            icon: { name: 'whatsapp', size: '1x' },
            title: 'Canais de contato',
            description: `Para atendimentos emergenciais, estamos disponíveis por telefone, WhatsApp e e-mail.`,
            titleMarginBottom: '8px'
          }"
        >
          <template v-slot:lead>
            <OmtIcons name="angle-right" mr="13" size="xl" color="var(--colors-light-primary-gray1)" />
          </template>
        </CardTile>
      </OmtRow>

      <OmtRow mb="16px" @click="openGuiaDeCoberturas">
        <CardTile
          v-bind="{
            icon: { name: 'memo-circle-check', size: '1x' },
            title: 'Guia de Coberturas',
            description: `Documento com as principais informações sobre o seguro, incluindo coberturas, assistências e benefícios disponíveis para utilização durante a viagem.`,
            titleMarginBottom: '8px'
          }"
        >
          <template v-slot:lead>
            <OmtIcons name="angle-right" mr="13" size="xl" color="var(--colors-light-primary-gray1)" />
          </template>
        </CardTile>
      </OmtRow>

      <OmtRow mb="16px" @click="openPdf(linkGuiaRapido)">
        <CardTile
          v-bind="{
            icon: { name: 'square-poll-horizontal', size: '1x' },
            title: 'Guia rápido',
            description: `Guia prático e resumido de informações essenciais sobre seu seguro viagem.`,
            titleMarginBottom: '8px'
          }"
        >
          <template v-slot:lead>
            <OmtIcons name="angle-right" mr="13" size="xl" color="var(--colors-light-primary-gray1)" />
          </template>
        </CardTile>
      </OmtRow>

      <OmtRow mb="16px" @click="cartaSeguroViagem" v-if="exibirCartaSeguroViagem">
        <CardTile
          v-bind="{
            icon: { name: 'earth-americas', size: '1x' },
            title: 'Carta Seguro Viagem',
            description: `Documento emitido em diversos idiomas.`,
            titleMarginBottom: '8px'
          }"
        >
          <template v-slot:lead>
            <OmtIcons name="angle-right" mr="13" size="xl" color="var(--colors-light-primary-gray1)" />
          </template>
        </CardTile>
      </OmtRow>

      <OmtRow mb="16px" @click="cotacaoSeguroViagem">
        <CardTile
          v-bind="{
            icon: { name: 'clipboard-list-check', size: '1x' },
            title: 'Cotação Seguro Viagem',
            description: `Opção de contratação com capitais segurados mais elevados e coberturas adicionais, de acordo com o perfil e necessidades da viagem.`,
            titleMarginBottom: '8px'
          }"
        >
          <template v-slot:lead>
            <OmtIcons name="angle-right" mr="13" size="xl" color="var(--colors-light-primary-gray1)" />
          </template>
        </CardTile>
      </OmtRow>
    </template>
  </OmtLayoutContainer>
</template>

<script>
import CardTile from "@/components/Molecules/CardTile";
import { isMobile } from "@/utils/utils";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

export default {
  components: {
    CardTile
  },
  data() {
    return {
      documentViagemName: "COBERTURAS SEGURO VIAGEM", // its unsafe way to find document
      linkGuiaRapido: `https://sftpmkt.blob.core.windows.net/corporativo/Quick%20Reference%20-%20Omint%20Seguro%20Viagem-V3%201.pdf`,
      linkGuiaDeCoberturas: `https://sftpmkt.blob.core.windows.net/corporativo/7_F3.pdf`,
      linkCotacaoSeguroViagem: "https://pages.omint.com.br/cotador-seguro-viagem/"
    };
  },
  mounted() {
    this.$root.$emit("hide-loading");
  },
  computed: {
    ...mapState("saude", ["perfil"]),
    ...mapState("myFiles", ["myFiles"]),
    ...mapGetters("saude", ["hasExclusiveTravelInsurance"]),
    exibirCartaSeguroViagem() {
      return !this.isExclusive;
    },
    isExclusive() {
      return this.$route.name === "safe-letter.intermediate.exclusivo" || this.hasExclusiveTravelInsurance;
    },
    isMobile() {
      return isMobile();
    }
  },
  methods: {
    ...mapActions("myFiles", ["listFiles"]),
    ...mapMutations("myFiles", ["SET_DOC"]),
    openInInternalViewer(url, name) {
      this.SET_DOC({ name, url });
      this.$router.push("/arquivo");
    },
    cartaSeguroViagem() {
      this.$router.push({ name: "safe-letter.list" });
    },
    cotacaoSeguroViagem() {
      this.openInInternalViewer(this.linkCotacaoSeguroViagem, "Cotação Seguro Viagem");
    },
    openPdf(destiny) {
      if (isMobile()) {
        window.location = destiny;
      } else {
        window.open(destiny, "_blank");
      }
    },
    async openGuiaDeCoberturas() {
      try {
        this.$root.$emit("show-loading");
        await this.listFiles();
        if (this.myFiles.length > 0) {
          const file = this.myFiles.find(file => file.name.toLowerCase() === this.documentViagemName.toLowerCase());

          if (file) {
            const url = file.itemCollection[0].Url;
            this.openInInternalViewer(url, file.name);
          }
        }
      } catch (error) {
        Swal.fire({
          title: "Aviso",
          text: "Não foi possível abrir o documento.",
          confirmButtonText: "OK"
        });
      } finally {
        this.$root.$emit("hide-loading");
      }
    },
    exibirContato() {
      this.$router.push({ name: "safe-letter.intermediate.contact" });
    },
    async redirectToFiles() {
      this.$router.push({ name: "myfiles" });
    }
  }
};
</script>
